import { render, staticRenderFns } from "./PercentageRented.vue?vue&type=template&id=2cebc24d&"
import script from "./PercentageRented.vue?vue&type=script&lang=ts&"
export * from "./PercentageRented.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports